import React, { useRef } from "react";
import { useHistory } from "react-router";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import PageHeader from "src/app/components/PageHeader/PageHeader";
import { Button } from "src/app/components/Button/Button";
import { ReactComponent as PlusIcon } from "src/images/plus-transparent.svg";
import { setSearchParam } from "src/utils/methods";
import InsightsDashboardSetupPane, {
  SETUP_MODE_QUERY_PARAM_KEY,
  SetupModes,
} from "src/app/components/InsightsDashboard/panes/InsightsDashboardSetupPane/InsightsDashboardSetupPane";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import { useQuery } from "src/app/methods/useQuery";
import { SocialInsightsDashboardList } from "src/app/components/InsightsDashboard/components/SocialInsightsDashboardList/SocialInsightsDashboardList";
import { IDNoResults } from "src/app/components/InsightsDashboard/components/IDNoResults/IDNoResults";

import "./SocialInsights.scss";

export const SocialInsightsDashboardsListPage = () => {
  const history = useHistory();
  const query = useQuery();
  const setupMode = query.get(SETUP_MODE_QUERY_PARAM_KEY) as
    | SetupModes
    | undefined;

  const { dashboardList, dashboardListFirstLoadDone } = useSelector(
    (state: RootState) => state.insightsDashboardReducer,
  );

  // Only used to satisfy InsightsDashboardSetupPane's prop type - this page has
  // no debounced-filters fetch effect for it to guard.
  const blockDebounce = useRef(true);

  if (!dashboardListFirstLoadDone) return null;

  return (
    <div className="social-insights-dashboards-list-page">
      {dashboardList.length > 0 ? (
        <>
          <div className="social-insights__header-row">
            <PageHeader
              title={
                <IDHFormattedMessage
                  id="front_social_insights"
                  defaultMessage="Social Insights"
                />
              }
              description={
                <IDHFormattedMessage
                  id="front_social_insights_description"
                  defaultMessage="Performance overview across brands, countries, platforms and influencer segments."
                />
              }
            />
            <Button
              size="small"
              variant="blue"
              onClick={() =>
                setSearchParam({
                  history,
                  key: SETUP_MODE_QUERY_PARAM_KEY,
                  value: SetupModes.Create,
                })
              }
            >
              <PlusIcon />
              <IDHFormattedMessage
                id="ws_create_dashboard"
                defaultMessage="Create Dashboard"
              />
            </Button>
          </div>

          <SocialInsightsDashboardList />
        </>
      ) : (
        <IDNoResults variant="noDashboard" />
      )}

      {setupMode && (
        <InsightsDashboardSetupPane
          loading={false}
          showPane={Boolean(setupMode)}
          blockDebounce={blockDebounce}
          setupMode={setupMode}
        />
      )}
    </div>
  );
};
